<template>
  <div class="editor-date-picker-container">
    <div v-if="label" class="editor-date-picker-label">{{ label }}</div>
    <el-date-picker
      ref="datePicker"
      v-model="pickerValue"
      type="month"
      v-bind="$attrs"
      v-on="$listeners"
      :popper-class="`editor-date-picker-popper ${
        displayPresent ? 'display-present-popper' : ''
      }`"
      :picker-options="pickerOptions"
      value-format="yyyy-MM"
      @change="handleChange"
    />
    <div
      v-if="displayPresent && isPresent"
      class="present-value-content"
      @click="handlePresentClick"
    >
      至今
    </div>
  </div>
</template>
<script>
let timer = null;
export default {
  name: "EditorDatePicker",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [Date, String, Object],
      default: "",
    },
    displayPresent: {
      type: Boolean,
      default: false,
    },
    isPresent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickerValue: this.value,
    };
  },
  computed: {
    pickerOptions() {
      if (this.displayPresent) {
        return {
          shortcuts: [
            {
              text: "至今",
              onClick: (picker) => {
                picker.$emit("pick", "");
                timer = setTimeout(() => {
                  this.$emit("change", "", true);
                }, 0);
              },
            },
          ],
        };
      } else {
        return {};
      }
    },
  },
  methods: {
    handleChange(value, isPresent) {
      this.pickerValue = value;
      this.$emit("change", value, isPresent);
    },
    handlePresentClick() {
      this.datePickerFocus();
    },
    datePickerFocus() {
      this.$refs.datePicker.focus();
    },
  },
  beforeDestroy() {
    clearTimeout(timer);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.editor-date-picker-container {
  position: relative;
  display: flex;
  flex-direction: column;
  .editor-date-picker-label {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .present-value-content {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 2px;
    width: calc(100% - 10px);
    height: calc(100% - 20px);
    padding: 0 15px;
    color: $text-color;
    font-size: 13px;
    background-color: $page-bg-sub-color;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .el-input {
    width: 100%;
    ::v-deep(.el-input__inner) {
      border-color: transparent;
      background-color: $page-bg-sub-color;
      color: $text-color;
      padding-left: 15px;
      padding-right: 15px;
      &:focus,
      &:hover {
        border-color: $hover-border-color;
      }
      &::placeholder {
        color: $placeholder-color;
      }
    }
    ::v-deep(.el-input__prefix) {
      display: none;
    }
  }
}
</style>
<style lang="scss">
@import "@/assets/css/variable.scss";
.editor-date-picker-popper {
  background-color: transparent !important;
  border-color: $select-border-color !important;
  background: linear-gradient(
    45deg,
    $select-bg-start-color 0%,
    $select-bg-middle-color 62%,
    $select-bg-end-color 100%
  );
  &.display-present-popper {
    &.has-sidebar {
      width: 324px;
    }
    .el-picker-panel__body-wrapper {
      position: relative;
      padding-bottom: 64px;
      overflow: hidden;
      .el-picker-panel__sidebar {
        position: absolute;
        bottom: 0;
        top: auto;
        width: 100%;
        height: 44px;
        background-color: transparent;
        border: none !important;
        border-top: 1px solid $sidebar-border-color !important;
        padding: 0 !important;
        transform: translateY(0) !important;
        .el-picker-panel__shortcut {
          text-align: center;
          color: $text-color;
          font-size: 13px;
          height: 100%;
          &:hover {
            color: $text-color;
          }
        }
      }
      .el-picker-panel__body {
        margin-left: 0;
        .el-picker-panel__content {
          margin-bottom: 0;
        }
      }
    }
  }
  .el-picker-panel__body-wrapper {
    .el-date-picker__header {
      border-bottom: none;
      .el-picker-panel__icon-btn,
      .el-date-picker__header-label {
        color: $text-color;
      }
    }
    .el-picker-panel__content {
      .el-year-table,
      .el-month-table {
        .cell {
          color: $text-color;
        }
        td.current:not(.disabled) .cell {
          color: $theme-color;
          background-color: rgba($color: #ff6644, $alpha: 0.1);
        }
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>
